var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8494 13.0933L26.5561 12.1133L22.1461 1.73C21.3528 -0.16 18.6461 -0.16 17.8528 1.73L13.4428 12.1367L2.17277 13.0933C0.119437 13.2567 -0.720563 15.8233 0.84277 17.1767L9.4061 24.5967L6.83944 35.61C6.37277 37.6167 8.54277 39.2033 10.3161 38.13L19.9994 32.2967L29.6828 38.1533C31.4561 39.2267 33.6261 37.64 33.1594 35.6333L30.5928 24.5967L39.1561 17.1767C40.7194 15.8233 39.9028 13.2567 37.8494 13.0933ZM19.9994 27.9333L11.2261 33.23L13.5594 23.2433L5.81277 16.5233L16.0328 15.6367L19.9994 6.23333L23.9894 15.66L34.2094 16.5467L26.4628 23.2667L28.7961 33.2533L19.9994 27.9333Z",
    fill: "#232B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.ba6fc0f09fbfc22f6426013656c9ea6f.svg";
export { ForwardRef as ReactComponent };